function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useReducer } from 'react';
import { WithInfoIcon, useIsMounted } from 'seagull';
import { serviceTemplateModel } from "../../../models";
import { utils } from "../../../utils";
import { StartBillingOnEnum } from "../../../types/api.model";
export const columnDefs = [{
  width: [160, 256]
},
// service name
{
  width: 180
},
// rate
{
  width: 104
},
// billing occurrence
{
  width: 104
},
// billing trigger
{
  width: 120
} // preapproved
];
export const headerItems = [{
  value: 'Service Name'
}, {
  value: 'Rate'
}, {
  value: 'Billing occurrence'
}, {
  value: /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "Manual"), ": Invoice is issued upon trigger of input units/hours or added charge to the billing cycle.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Automatic"), ": Invoice is issued on the date selected in the agreement.")
  }, "Billing trigger")
}, {
  value: /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: /*#__PURE__*/React.createElement(React.Fragment, null, "An upper limit for automatic billing. If exceeded or not specified, the bill will require manual client approval.")
  }, "Preapproved")
}];

/** Newly created services will be highlighted. */
export const useNewServices = () => {
  const isMounted = useIsMounted();
  const [newServices, dispatch] = useReducer((state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.serviceId]: action.isAdding
  }), {});
  const markServiceAsNew = useCallback(serviceId => {
    dispatch({
      isAdding: true,
      serviceId
    });
    setTimeout(() => {
      // Cleanup service from newServices so next time it's edited it will flash again.
      isMounted() && dispatch({
        isAdding: false,
        serviceId
      });
    }, 5000);
  }, []);
  return {
    newServices,
    markServiceAsNew
  };
};
export function getDiscountedPriceByServiceTemplate(serviceTemplate) {
  const {
    cost
  } = serviceTemplate;
  const {
    discount
  } = cost;
  return serviceTemplateModel.isFixedPrice(cost) || serviceTemplateModel.isVariablePrice(cost) ? utils.applyDiscount(cost.price, discount) : {
    minPrice: cost.minPrice != null ? utils.applyDiscount(cost.minPrice, discount) : null,
    maxPrice: utils.applyDiscount(cost.maxPrice, discount)
  };
}
export function getSkipBillingOnAcceptance(agreementData, businessSettings) {
  const isSkipBillingOnAcceptance = businessSettings !== null && businessSettings !== void 0 && businessSettings.billUpfront ? (businessSettings === null || businessSettings === void 0 ? void 0 : businessSettings.startBillingOn) === StartBillingOnEnum.SkipBillingOnAcceptance : true;
  return agreementData.isActiveAgreement() || isSkipBillingOnAcceptance;
}